import styles from "../../assets/styles/Feedback/Feedback.module.scss";
import React, { useMemo, useState } from "react";
import {
  AppPage,
  MimaButton,
  MimaNewFilter,
  MimaTable,
} from "../../components";
import { AnimatePresence } from "framer-motion";
import moment from "moment";
import MimaOptionMenu from "../../components/OptionMenu/";
import {
  ActivateFeedbackContainer,
  ConfigFeedbackContainer,
} from "../../containers";
import constant from "../../utils/constant";

const FeedbackConfig = ({
  closeModal,
  filterHandler,
  setOpenConfigModal,
  openConfigModal,
  activationModal,
  setActivationModal,
  feedbackConfigData,
  isLoading,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [data, setData] = useState({});

  const filterByData = [{ value: "Date", key: "createdAt" }];

  const tableData = useMemo(() => {
    if (feedbackConfigData?.status === constant.Success) {
      return feedbackConfigData?.data?.reviews || [];
    }
    return [];
  }, [feedbackConfigData]);

  const tableColumns = [
    {
      Header: "Created Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original?.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },

    {
      Header: "Configuration Type",
      accessor: "tag",
    },
    {
      Header: "Feature",
      accessor: "key",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const statusName = status === true ? "Activated" : "Not Activated";
        return <span>{statusName}</span>;
      },
    },
    {
      Header: "Activation Date",
      accessor: "updatedAt",
      Cell: ({ cell }) => {
        const date = cell.row.original?.updatedAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <MimaOptionMenu
            options={[
              {
                label: "Activate Configuration",
                value: "Activate Configuration",
              },
            ]}
            onOptionSelected={(option) => {
              if (option.value === "Activate Configuration") {
                setActivationModal(true);
                setData(item);
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Feedback Configuration">
      <>
        <div className={styles.btn}>
          <div>
            <MimaButton
              title={showFilter ? "Close Filter" : "Filter"}
              onClick={() => setShowFilter(!showFilter)}
            />
          </div>
          <MimaButton
            title="Configure Feedback"
            onClick={() => {
              setOpenConfigModal(true);
            }}
          />
        </div>
        <MimaNewFilter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          filterByData={filterByData}
          filterHandler={filterHandler}
        />
        <MimaTable
          tableData={tableData}
          tableColumns={tableColumns}
          searchPlaceholder="Search Subscription"
          searchVariant="wide"
          totalItems={feedbackConfigData?.data?.totalCounts}
          onLimitChange={onLimitChange}
          isLoading={isLoading}
          isFetching={isFetching}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
        />
        {(openConfigModal || activationModal) && (
          <div className="modal">
            <AnimatePresence>
              {openConfigModal && (
                <ConfigFeedbackContainer closeModal={closeModal} />
              )}

              {activationModal && (
                <ActivateFeedbackContainer
                  closeModal={closeModal}
                  data={data}
                />
              )}
            </AnimatePresence>
          </div>
        )}
      </>
    </AppPage>
  );
};
export default FeedbackConfig;
